import { createSlice } from "@reduxjs/toolkit";
import { EmailAddress } from "../models/EmailAddress";
import { EmailAddressTopic } from "../models/EmailAddressTopic";
import { EmailTopic } from "../models/EmailTopic";

const EmailTopicsInitialState: {
	topics: EmailTopic[];
	topicSelected: EmailTopic | null;
	addresses: EmailAddress[];
	// Second result set of GetEmailTopics: the edit form needs the address ids per recipient type,
	// while the grid only gets their names.
	addressTopics: EmailAddressTopic[];
} = {
	topics: [],
	topicSelected: null,
	addresses: [],
	addressTopics: [],
};

export const EmailTopicsReducer = createSlice({
	name: "__",
	initialState: EmailTopicsInitialState,
	reducers: {
		setTopics(state, { payload }) {
			state.topics = payload;
		},
		setTopicSelected(state, { payload }) {
			state.topicSelected = payload;
		},
		setAddresses(state, { payload }) {
			state.addresses = payload;
		},
		setAddressTopics(state, { payload }) {
			state.addressTopics = payload;
		},
	},
});
